import { Location } from '@frontend/common';
import React from 'react';

import { NumberInput } from '../number-input/number-input.component';
import useLocationInput from './location-input.controller';

const ID = 'location-input';
export interface LocationInputProps {
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
    submitted: boolean;
    onChange: (newValue: Location) => void;
    value?: Location;
}

export const LocationInput = (props: LocationInputProps) => {
    const viewProps = useLocationInput(props);

    return (
        <form
            id={ID}
            className='flex w-full flex-col'>
            <label>{props.label}</label>
            <div className='flex w-full flex-row'>
                <div className='m-1 w-25'>
                    <NumberInput
                        id='x'
                        label='x'
                        required={props.required}
                        submitted={props.submitted}
                        value={viewProps.location.x}
                        onChange={(value) => {
                            viewProps.changeLocation({ ...viewProps.location, x: value });
                        }}
                    />
                </div>
                <div className='m-1 w-25'>
                    <NumberInput
                        id='y'
                        label='y'
                        required={props.required}
                        submitted={props.submitted}
                        value={viewProps.location.y}
                        onChange={(value) => {
                            viewProps.changeLocation({ ...viewProps.location, y: value });
                        }}
                    />
                </div>
                <div className='m-1 w-25'>
                    <NumberInput
                        id='z'
                        label='z'
                        required={props.required}
                        submitted={props.submitted}
                        value={viewProps.location.z}
                        onChange={(value) => {
                            viewProps.changeLocation({ ...viewProps.location, z: value });
                        }}
                    />
                </div>
                <div className='m-1 w-25'>
                    <NumberInput
                        id='rotation'
                        label='rotation'
                        required={props.required}
                        min={0}
                        max={359}
                        submitted={props.submitted}
                        value={viewProps.location.rotation}
                        onChange={(value) => {
                            viewProps.changeLocation({ ...viewProps.location, rotation: value });
                        }}
                    />
                </div>
            </div>
        </form>
    );
};
